/**
*  UI-REFACTORED
*    FROM --> ./legacy-web/src/main/js/awardFinder/resources/js/homePage/homepageSortUtil.js
*    TO   --> ./webapps/homepage-web/src/main/assets/js/home/award-finder/homepage-sort-util.js
**/

var HomepageSortUtil = {};

HomepageSortUtil = (function() {

	var _defaults = {
		milesAscending: false,
		alphaAscending: true,
		sort: 'miles',
		sortBtn_active: $('#sortMiles')
	};

	var _milesAscending = _defaults.milesAscending;
	var _alphaAscending = _defaults.alphaAscending;
	var _currentSort = _defaults.sort;
	var _sortBtn_active = '';


	function sortByMiles() {
		console.log('sorting ' + _milesAscending);
		if(_currentSort != 'miles') {
			_milesAscending = true; // toggle
		}
		applySorts(miles, _milesAscending, alpha, true);
		_milesAscending = !_milesAscending;
		_currentSort = 'miles';
	}

	function sortAlpha() {
		if(_currentSort != 'alpha') {
			_alphaAscending = true;
		}
		applySorts(alpha, _alphaAscending, miles, true);
		_alphaAscending = !_alphaAscending;
		_currentSort = 'alpha';
	}

	/**
	 * sorts with sortA most important...
	 */
	function applySorts(sortA, aAscending, sortB, bAscending, sortC, cAscending) {

		$('#listView > .list-row').sortElements(function(a,b) {

			var $a = $(a);
			var $b = $(b);

			var aRet = sortA($a,$b, aAscending);

			if(aRet != 0 || sortB === undefined) {
				return aRet;
			}

			var bRet = sortB($a,$b, bAscending);


			if(bRet != 0 || sortC === undefined) {
				return bRet;
			}

			return sortC($a,$b, cAscending);
		});


	}

	function reset() {
		_milesAscending = _defaults.milesAscending;
		_alphaAscending = _defaults.alphaAscending;
		_currentSort = _defaults.sort;
		_sortBtn_active = '';

		$('#sortContainer button').removeClass('on').find('.arrow-sort').removeClass('arrow-asc arrow-desc');
		_defaults.sortBtn_active.addClass('on').find('.arrow-sort').addClass('arrow-asc');
	}

	/**
	 * for upsell at bottom: ascending
	 * returns -1 if a is regular and b upsell
	 * returns 1 if b is regular and a upsell
	 * returns 0 if both regular or both upsell
	 */
	function upsell($a,$b, ascending) {
		var mult = (ascending) ? -1 : 1;
		var aUpsell = $a.hasClass('upsell');
		var bUpsell = $b.hasClass('upsell');
		if(bUpsell && !aUpsell) {
			return 1*mult;
		} else if(aUpsell && !bUpsell) {
			return -1*mult;
		}
		return 0;
	}

	/**
	 * returns 1 if a miles greater than b miles
	 */
	function miles($a,$b, ascending) {
		var mult = (ascending) ? 1 : -1;
		var milesA = +$a.find('.num').text().replace(/,/g, ''); // remove comma, convert to number
		var milesB = +$b.find('.num').text().replace(/,/g, ''); // remove comma, convert to number
		if(milesA > milesB) {
			return 1*mult;
		}
		else if (milesA < milesB) {
			return -1*mult;
		}
		return 0;
	}

	/**
	 * returns 1 if a greater than b alphabetically
	 */
	function alpha($a,$b, ascending) {
		var mult = (ascending) ? 1 : -1;
		if ($a.find('.city').text() > $b.find('.city').text()) {
			return 1*mult;
		}
		else {
			return -1*mult;
		}
	}

	var initSorting = function() {

		//Sort buttons

		var $sortButtons = $('#sortContainer button');
		$sortButtons.on('click' , function(e){
			var self = this;

			if($(self).hasClass('on')){
				_sortBtn_active = self;
			}

			if(self != _sortBtn_active){
				$sortButtons.removeClass('on');
				$sortButtons.find('.arrow-sort').removeClass('arrow-asc arrow-desc');

				$(self).addClass('on');
				$(self).find('.arrow-sort').addClass('arrow-asc');
				_sortBtn_active = self;
			}
			else {
				$(self).find('.arrow-sort').toggleClass('arrow-asc arrow-desc');
			}

			if(self.id == 'sortMiles') {
				sortByMiles();
			}
			if(self.id == 'sortAlpha') {
				sortAlpha();
			}
			$('#scroll-container').animate({ scrollTop: 0 }, "medium");
		});

	};


	return {
		sortByMiles : sortByMiles,
		sortAlpha : sortAlpha,
		reset : reset,
		initSorting : initSorting
	};
}());

/**
 * the actual jQuery function that sorts the div elements on the page
 * and re-arranges
 */
jQuery.fn.sortElements = (function(){

    var sort = [].sort;
    return function(comparator) {

        var placements = this.map(function(){

            var  parentNode = this.parentNode,

                // Since the element itself will change position, we have
                // to have some way of storing its original position in
                // the DOM. The easiest way is to have a 'flag' node:
                nextSibling = parentNode.insertBefore(
                    document.createTextNode(''),
                    this.nextSibling
                );

            return function() {
                // Insert before flag:
                parentNode.insertBefore(this, nextSibling);
                // Remove flag:
                parentNode.removeChild(nextSibling);

            };

        });

        return sort.call(this, comparator).each(function(i){
            placements[i].call(this);
        });

    };

})();
